import { render, staticRenderFns } from "./LocalMode.vue?vue&type=template&id=d6b134f4&scoped=true&"
import script from "./LocalMode.vue?vue&type=script&lang=ts&"
export * from "./LocalMode.vue?vue&type=script&lang=ts&"
import style0 from "./LocalMode.vue?vue&type=style&index=0&id=d6b134f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b134f4",
  null
  
)

export default component.exports